import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'antd';
import { PropertySuccess as PropertySuccessIcon } from '~components/svgs';
import { propertySections } from '~constants/listing-management';

export default class SubmitSuccess extends React.PureComponent {
  render() {
    const { t, isPublished, section } = this.props;

    return (
      <div className="submit-success">
        <PropertySuccessIcon className="submit-success__success-icon" />
        <div className="submit-success__content">
          <Choose>
            <When condition={isPublished}>
              {t(`cms:cms.pending_approval.content.${section.toLowerCase()}.update_successfully`)}
            </When>
            <Otherwise>{t('cms:cms.pending_approval.content.publish_successfully')}</Otherwise>
          </Choose>
        </div>
        <div className="submit-success__description">
          {t('cms:cms.pending_approval.description.submit_successfully')}
        </div>
        <div className="submit-success__btn-wrap">
          <Button size="large" type="primary" ghost onClick={this.props.onContinueEditing}>
            {t('cms:cms.pending_approval.continue_editing.btn')}
          </Button>
          <Button size="large" type="primary" onClick={this.props.onBackToHomeList}>
            {t('cms:cms.pending_approval.back_to_home_list.btn')}
          </Button>
        </div>
      </div>
    );
  }
}

SubmitSuccess.propTypes = {
  t: PropTypes.func.isRequired,
  isPublished: PropTypes.bool,
  section: PropTypes.oneOf([
    propertySections.PROPERTY_DETAILS,
    propertySections.GALLERY_MANAGEMENT,
  ]),
  onContinueEditing: PropTypes.func,
  onBackToHomeList: PropTypes.func,
};

SubmitSuccess.defaultProps = {
  t: () => {},
  isPublished: false,
  section: propertySections.PROPERTY_DETAILS,
  onContinueEditing: () => {},
  onBackToHomeList: () => {},
};
